/* eslint-disable react-hooks/exhaustive-deps */
import { Modal, Button, Table } from "semantic-ui-react";
import YesNoRadioCheckBoxSwitch from "../components/YesNoRadioCheckBoxSwitch";
import getTrackedChanges from "../functions/getTrackedChangesAPI";
import { jsonDiff, processTrackedChanges, updateTrackedChanges } from "../functions/trackedChangesFunctions";
import { useDispatch, useSelector } from "react-redux";
import { editModeOff, selectEditMode } from "../slices/editMode/editModeSlice";
import { selectCurrentUserApiToken, selectCurrentUserName, selectSseConnectionId } from "../slices/currentUser/currentUserSlice";
import { useEffect, useState } from "react";
import { JsonVersionComparison } from "./VersionDifferencesFunctions";
import updateTrackedChangesOnServer from "../functions/updateTrackedChangesAPI";
import { selectAllResources } from "../slices/resourceCollection/resourceCollectionSlice";
import { changesCleared, selectChangedResourcesList } from "../slices/changedResourcesList/changedResourcesListSlice";
import deleteEmptyElementsInObjectRecursive from "../functions/deleteEmptyJsonElements";
import updateFhirJson from "../functions/updateFhirJsonAPI";
import { triggerRefreshOn } from "../slices/triggerRefresh/triggerRefreshSlice";
import StringEntry from "../datatypeComponents/StringEntry";
import { loadTrackedChanges, selectAllTrackedChanges, selectTrackChangesStatus } from "../slices/trackChanges/trackChangesSlice";

const submitChangeTrackingChanges = async (dispatch, apiToken, setTrackChangesModalState, foi,
    changesState, newResourceJson, resourceCollection, changedResourcesList, connectionId,
    commentsState, userName) => {

    let revisedChanges = JSON.parse(JSON.stringify(changesState));
    if (Object.keys(commentsState).length > 0) {
        for (let key of Object.keys(commentsState)) {
            if (commentsState[key]) {
                revisedChanges[key]["comments"].push([
                    (new Date()).toLocaleString(undefined, {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: '2-digit'
                    }),
                    userName,
                    commentsState[key]
                ]);
            }
        }
    }

    await updateTrackedChangesOnServer(foi, revisedChanges, apiToken);
    console.log("---------saveAllChanges ---------------------------")
    const filteredResourceCollection = resourceCollection.filter(entry => (changedResourcesList.includes(entry.id) || foi === entry.id));
    let primaryEntryUpdated;
    for (const entry of filteredResourceCollection) {
        let entryFoi = entry.id;
        if (entryFoi === foi) {
            primaryEntryUpdated = entry;
        } else {
            let resourceJson = JSON.parse(JSON.stringify(entry.revisedResourceJson));
            let title = entry.displayTitle;
            deleteEmptyElementsInObjectRecursive(resourceJson);
            console.log("updating server for " + entryFoi)
            await updateFhirJson(entryFoi, resourceJson, title, apiToken, connectionId,
                undefined, null, null, undefined, null
            );
        }
    }
    let resourceJson;
    let title;
    if (primaryEntryUpdated && newResourceJson) {
        resourceJson = newResourceJson;
        title = primaryEntryUpdated.displayTitle; //TODO -- change tracking and changing display title may not cooperate
        let trimmedResourceJson = deleteEmptyElementsInObjectRecursive(JSON.parse(JSON.stringify(resourceJson)));
        let response = await updateFhirJson(foi, trimmedResourceJson, title, apiToken, connectionId,
            undefined, null, null, undefined, true);
        if (response?.success) {
            //if (addToast) {
            //    addToast('The resource has been updated.', { appearance: 'success' });
            //}
            dispatch(changesCleared());
            dispatch(editModeOff());
            dispatch(triggerRefreshOn());
        }
    } else {
        alert("The Resource was not updated.");
    }
    setTrackChangesModalState(prevState => { return { ...prevState, modalOpen: false }; });
}

const TrackChangesModal = ({ foi, setTrackChangesModalState, parentResourceDetail }) => {
    const dispatch = useDispatch();
    const editMode = useSelector(selectEditMode);

    const apiToken = useSelector(selectCurrentUserApiToken);
    const userName = useSelector(selectCurrentUserName);
    const oldResourceJson = parentResourceDetail?.resourceJson;
    const newResourceJson = parentResourceDetail?.revisedResourceJson;
    const resourceCollection = useSelector(state => selectAllResources(state));
    const changedResourcesList = useSelector(state => selectChangedResourcesList(state));
    const connectionId = useSelector(selectSseConnectionId);
    const trackedChangesStatus = useSelector(selectTrackChangesStatus);
    const allTrackedChanges = useSelector(selectAllTrackedChanges);

    const [versionDifferencesState, setVersionDifferencesState] = useState();
    const [versionDifferencesInterfaceState, setVersionDifferencesInterfaceState] = useState({
        "justTheDifferences": true, "acceptAllVersion": null, "rejectAllVersion": null
    });
    const [changesState, setChangesState] = useState({});
    const [commentsState, setCommentsState] = useState({});

    const loadInitialTrackedChanges = async (foi) => {
        let changes = {};
        if (trackedChangesStatus === "succeeded") {
            for (let item of allTrackedChanges) {
                changes[item.id] = JSON.parse(JSON.stringify(item));
            }
        } else {
            changes = await getTrackedChanges(foi, apiToken);
        }
        if (editMode) {
            updateTrackedChanges(changes, oldResourceJson, newResourceJson, userName);
        }
        let changesArray = [];
        for (const path in changes) {
            let changeObject = changes[path];
            changeObject["id"] = path;
            changesArray.push(changeObject);
        }
        setChangesState(changes);
        dispatch(loadTrackedChanges({ trackChanges: changesArray }));
    }

    useEffect(() => {
        loadInitialTrackedChanges(foi);
    }, []);

    useEffect(() => {
        if (oldResourceJson && newResourceJson && changesState &&
            Object.keys(changesState).length > 0 &&
            Object.keys(oldResourceJson).length > 0 && Object.keys(newResourceJson).length > 0) {
            let allAcceptedResourceJson;
            let allRejectedResourceJson;
            if (!versionDifferencesInterfaceState.acceptAllVersion) {
                allAcceptedResourceJson = JSON.parse(JSON.stringify(newResourceJson));
            } else {
                allAcceptedResourceJson = JSON.parse(JSON.stringify(versionDifferencesInterfaceState.acceptAllVersion));
            }
            if (!versionDifferencesInterfaceState.rejectAllVersion) {
                allRejectedResourceJson = JSON.parse(JSON.stringify(oldResourceJson));
            } else {
                allRejectedResourceJson = JSON.parse(JSON.stringify(versionDifferencesInterfaceState.rejectAllVersion));
            }
            processTrackedChanges(changesState, allAcceptedResourceJson, allRejectedResourceJson);
            setVersionDifferencesInterfaceState(prevState => {
                return {
                    ...prevState, "acceptAllVersion": allAcceptedResourceJson, "rejectAllVersion": allRejectedResourceJson
                }
            });
        }
    }, [changesState]);

    useEffect(() => {
        if (versionDifferencesInterfaceState.acceptAllVersion && versionDifferencesInterfaceState.rejectAllVersion) {
            setVersionDifferencesState(jsonDiff(versionDifferencesInterfaceState.acceptAllVersion, versionDifferencesInterfaceState.rejectAllVersion))
        }
    }, [versionDifferencesInterfaceState]);

    const modalContent = <Modal.Content style={{ paddingTop: "4px", textAlign: "center" }}>
        {editMode &&
            <Button style={{ padding: "6px", position: "absolute", left: "6px", top: "2px" }}
                className="formButton positive"
                content="Submit and Save All Changes"
                onClick={() => {
                    submitChangeTrackingChanges(dispatch, apiToken, setTrackChangesModalState,
                        foi, changesState, versionDifferencesInterfaceState.acceptAllVersion,
                        resourceCollection, changedResourcesList, connectionId, commentsState,
                        userName
                    );
                }}
                disabled={!versionDifferencesInterfaceState.acceptAllVersion} />
        }
        <Button style={{ padding: "6px", position: "absolute", right: "6px", top: "2px" }}
            className="formButton negative"
            content="✖"
            onClick={() => {
                if (editMode) {
                    let changesArray = [];
                    let scrubbedChanges = JSON.parse(JSON.stringify(changesState));
                    if (Object.keys(commentsState).length > 0) {
                        for (let key of Object.keys(commentsState)) {
                            if (commentsState[key]) {
                                scrubbedChanges[key]["comments"].push([
                                    (new Date()).toLocaleString(undefined, {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric',
                                        hour: 'numeric',
                                        minute: '2-digit'
                                    }),
                                    userName,
                                    commentsState[key]
                                ]);
                            }
                        }
                    }
                    for (const path in scrubbedChanges) {
                        let changeObject = scrubbedChanges[path];
                        changeObject["id"] = path;
                        changesArray.push(changeObject);
                    }
                    dispatch(loadTrackedChanges({ trackChanges: changesArray }));
                }
                setTrackChangesModalState(prevState => { return { ...prevState, modalOpen: false }; });
            }} />
        <span style={{ padding: "6px" }}>
            <YesNoRadioCheckBoxSwitch elementName={"justTheDifferences"}
                labelElementName={"Only show the differences?"}
                flatElementValue={true} togglable={false} thin={true} fontSize={"14px"}
                alternativeValues={[true, false]}
                alternativeLabels={["Just the Differences", "Full JSON"]}
                startingValue={versionDifferencesInterfaceState.justTheDifferences}
                setter={setVersionDifferencesInterfaceState} />
        </span>
        <div style={{ marginTop: "4px", textAlign: "left" }}>
            {(changesState && Object.keys(changesState).length > 0) ?
                <>
                    {versionDifferencesInterfaceState.justTheDifferences ?
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Path</Table.HeaderCell>
                                    <Table.HeaderCell>Before Version</Table.HeaderCell>
                                    <Table.HeaderCell>Before Value</Table.HeaderCell>
                                    <Table.HeaderCell>After Version</Table.HeaderCell>
                                    <Table.HeaderCell>After Value</Table.HeaderCell>
                                    <Table.HeaderCell>Log and Comments</Table.HeaderCell>
                                    <Table.HeaderCell>Status</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {Object.keys(changesState)
                                    .map((key, keyIndex) => {
                                        let item = changesState[key];
                                        return <Table.Row key={keyIndex}>
                                            <Table.Cell>{key}</Table.Cell>
                                            <Table.Cell>{item.pretrackedversion}</Table.Cell>
                                            <Table.Cell>{(item.pretrackedvalue && typeof item.pretrackedvalue === "object") ?
                                                JSON.stringify(item.pretrackedvalue)
                                                :
                                                item.pretrackedvalue !== undefined ?
                                                    item.pretrackedvalue?.toString() : "[No value.]"}</Table.Cell>
                                            <Table.Cell>{item.savedversion}</Table.Cell>
                                            <Table.Cell>
                                                {(item.savedvalue && typeof item.savedvalue === "object") ?
                                                    JSON.stringify(item.savedvalue)
                                                    :
                                                    item.savedvalue !== undefined ?
                                                        item.savedvalue?.toString() : "DELETED"}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {item.versionlog?.length > 0 &&
                                                    item.versionlog.map((revised, revisedIndex) => {
                                                        let versionNumber = revised[0];
                                                        let userName = revised[1];
                                                        return <div key={revisedIndex}>
                                                            v{versionNumber} changed by {userName}
                                                        </div>;
                                                    })}
                                                {item.comments?.length > 0 &&
                                                    item.comments.map((comment, commentIndex) => {
                                                        let date = comment[0];
                                                        let name = comment[1];
                                                        let string = comment[2];
                                                        return <div key={commentIndex}>
                                                            {date} <b>{name}:</b> {string}
                                                        </div>;
                                                    })}
                                                {(editMode && item.status === "active") &&
                                                    <StringEntry elementName={key} fieldLabel='Comment'
                                                        startingValue={commentsState[key] || ""}
                                                        setResourceState={setCommentsState} />
                                                }
                                            </Table.Cell>
                                            <Table.Cell>
                                                {item.status}
                                                {(editMode && item.status === "active") &&
                                                    <>
                                                        <br />
                                                        <Button style={{ color: "#000000", width: "97%", margin: "0px" }}
                                                            className="formButton navigationButton printButton"
                                                            content="Accept"
                                                            onClick={() => {
                                                                setChangesState(prevState => {
                                                                    return {
                                                                        ...prevState,
                                                                        [key]: {
                                                                            ...prevState[key],
                                                                            status: "accept"
                                                                        }
                                                                    };
                                                                })
                                                            }}
                                                        />
                                                        <Button style={{ color: "#000000", width: "97%", margin: "0px" }}
                                                            className="formButton navigationButton printButton"
                                                            content="Reject"
                                                            onClick={() => {
                                                                setChangesState(prevState => {
                                                                    return {
                                                                        ...prevState,
                                                                        [key]: {
                                                                            ...prevState[key],
                                                                            status: "reject"
                                                                        }
                                                                    };
                                                                })
                                                            }}
                                                        />
                                                    </>}
                                            </Table.Cell>
                                        </Table.Row>
                                    })
                                }
                            </Table.Body>
                        </Table>
                        :
                        <>
                            <br />
                            {versionDifferencesState &&
                                <JsonVersionComparison jsonDifferences={versionDifferencesState} />}
                        </>
                    }
                </>
                :
                <p><br />There are no tracked changes.</p>
            }
        </div>
    </Modal.Content>

    return (
        <Modal
            style={{ padding: "0px", margin: "0px", width: "85%", maxHeight: "96vh", overflowY: "auto" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={true}
            centered={false}
            content={modalContent}
        />
    )
};

export default TrackChangesModal;